import styled from 'styled-components';
import { colorState } from '../../Universal/Foundation';
export const customCategoryStyles = {
  content: {
    minWidth: '30%',
    minHeight: '20vh'
  },
  overlay: {
    backgroundColor: 'rgba(114, 114, 114, 0.294)'
  }
};
export const customConfirmationStyles = {
  content: {
    minWidth: '20%',
    minHeight: '10vh'
  },
  overlay: {
    backgroundColor: 'rgba(114, 114, 114, 0.294)'
  }
};
